import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';

interface VerificationResponse {
    result: number;
}

@Component({
    selector: 'app-verify',
    templateUrl: './verify.component.html',
    styleUrls: ['./verify.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, NgIf],

})

export class VerifyDocumentComponent implements OnInit {
    selectedFile: File | null = null;
    isDragOver = false;
    isUploading = false;
    verificationResult: number | null = null;
    private apiUrl = 'https://person.mhnexus.com/api/v1/signingcloud/verify-document';

    constructor(private http: HttpClient) { }

    ngOnInit(): void {
    }

    onDragOver(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();
        this.isDragOver = true;
    }

    onDragLeave(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();
        this.isDragOver = false;
    }

    onDrop(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();
        this.isDragOver = false;

        const files = event.dataTransfer?.files;
        if (files && files.length > 0) {
            const file = files[0];
            if (this.isValidPdfFile(file)) {
                this.selectedFile = file;
            } else {
                this.showError('Please upload a valid PDF file');
            }
        }
    }

    onFileSelected(event: Event): void {
        const fileInput = event.target as HTMLInputElement;
        if (fileInput.files && fileInput.files.length > 0) {
            const file = fileInput.files[0];
            if (this.isValidPdfFile(file)) {
                this.selectedFile = file;
            } else {
                this.showError('Please upload a valid PDF file');
            }
        }
    }

    isValidPdfFile(file: File): boolean {
        return file.type === 'application/pdf';
    }

    removeFile(): void {
        this.selectedFile = null;
        this.verificationResult = null;
    }

    verifyDocument(): void {
        if (!this.selectedFile) {
            return;
        }

        this.isUploading = true;
        this.verificationResult = null;

        const formData = new FormData();
        formData.append('file', this.selectedFile);

        this.http.post<VerificationResponse>(this.apiUrl, formData)
            .subscribe({
                next: (response) => {
                    this.verificationResult = response.result;
                    this.isUploading = false;
                },
                error: (error) => {
                    console.error('Verification error:', error);
                    this.showError('An error occurred during verification. Please try again.');
                    this.isUploading = false;
                }
            });
    }

    private showError(message: string): void {
        // You can implement a proper error handling mechanism here
        // For now, we'll just use an alert
        alert(message);
    }
}